import React, {  } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';

import CustomDropdownWithButtonAndPrompt from 'components/base/CustomDropdownWithButtonAndPrompt';
import { PermissionCodes } from 'config/PermissionCodes';
import './BrandSelectDropdown.scss';

function BrandDropdownWithButtonAndPrompt({
  title,
  valueFieldName,
  customOnChange = () => { },
  onFocus = () => { },
  description,
  hasAddButton = false,
  addButtonInfo,
  promptConfig,
  isPrompt = false,
  formErrorId = valueFieldName,
  defaultFilter = {},
  labelContainPk = true,
}) {
  const { watch, formState: { errors }, setValue } = useFormContext();
  const watchBrand = watch(valueFieldName)
  const defaultValue = {
    value: watchBrand,
    label: labelContainPk 
      ? `[ID: ${watchBrand?.pk}] ${watchBrand?.name}`
      : watchBrand?.name,
  }
  const { brandList } = useSelector((state) => ({
    brandList: state.brand.brandList,
  }));

  const defaultAddButtonInfo = {
    title: 'Create Now',
    requires: PermissionCodes.addBrand,
    customClass:
      'general-section-add-new-brand btn-add-button-common',
  }
  const onSelectChange = (value) => {
    if (valueFieldName) {
      setValue(valueFieldName, value?.value || {}, { shouldDirty: true })
    }
    customOnChange(value?.value);
  };

  return (
    <CustomDropdownWithButtonAndPrompt
      title={title}
      description={description}
      titleStyle={isPrompt ? '' : 'create-section-label-no-top-space'}
      defaultValue={defaultValue}
      setValue={onSelectChange}
      source={brandList}
      hasAddButton={hasAddButton}
      addButtonInfo={hasAddButton ? { ...defaultAddButtonInfo, ...addButtonInfo } : {}}
      onFocus={onFocus}
      labelContainPk={labelContainPk}
      errors={errors}
      formErrorId={formErrorId}
      promptConfig={promptConfig}
      loadMoreAction={'brand/getCurrentPageBrands'}
      filterAction={'brand/getCurrentPageBrands'}
      defaultFilter={defaultFilter}
    />
  )
}

export default BrandDropdownWithButtonAndPrompt;
